import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import "react-form-wizard-component/dist/style.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  addEmployeeData,
  getEmployeeID,
  getEmployeeKeys,
  getEmployeeListDetailsByGUID,
  getObserverName,
} from "./Service/employeeService";
import { TostMsg } from "../../../App";
import { Dropdown } from "primereact/dropdown";
import { updateEmployee } from "../MyProfile/Service/profileService";
import DynamicEmployeeForm from "./DynamicEmployeeForm";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.lazy(
  () => import("../../../Shared/Sidebar/ComponentLoader"),
);

function AddNewEmployee() {
  const { GUID } = useParams();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const toster = useContext(TostMsg);
  const [AddMore, setAddMore] = useState(0);
  const [Isloading, setIsloading] = useState(false);
  const [BasicInfoFormShow, setBasicInfoFormShow] = useState(true);
  const [EmplyeeInfoFormShow, setEmplyeeInfoFormShow] = useState(false);
  const [PersonalInfoFormShow, setPersonalInfoFormShow] = useState(false);
  const [observerData, setObserverData] = useState([]);
  const [employeeUpdate, setEmployeeUpdate] = useState(false);
  const [employeeDelete, setEmployeeDelete] = useState(false); // If future requirement.
  const [employeeCreate, setEmployeeCreate] = useState(false);
  const [employeeHeader, setEmployeeHeader] = useState("");
  const [employeeEditDetails, setEmployeeEditDetails] = useState([]);
  const [employeeKeyDeta, setEmployeeKeyDeta] = useState([]);
  const submitActionRef = useRef("");
  const [backButtonHide, setBackButtonHide] = useState(true);
  const [countryCode, setCountryCode] = useState([]);
  const [employeeAddId, setEmployeeAddId] = useState("");
  const [countryError, setScountryError] = useState("");
  const history = useHistory();

  useEffect(() => {
    getObserverNameList();
    permissionAccouncementList();
    GetMasterSystemAlertList();
    getEmployeeKeysData();
    getMasterCountryCode();
    getmasterZoneList();
    getmasterRegionList();
    if (GUID) {
      fetchEmployeeIdData();
    }
  }, []);

  useEffect(() => {
    if (employeeEditDetails) {
      const basicInfoData = {
        firstName: employeeEditDetails[0]?.FirstName,
        middlename: employeeEditDetails[0]?.MiddleName,
        lastName: employeeEditDetails[0]?.LastName,
        employmentid: employeeEditDetails[0]?.EmpKeyValues?.find(
          (item) => item?.KeyName === "EmploymentId",
        )?.InferredValue,
        DOJ: employeeEditDetails[0]?.DateOfJoining.split("T")[0],
        ProfileImage: employeeEditDetails[0]?.ProfileImage,
        reportingmanager: employeeEditDetails[0]?.OverseerId,
        selectedCountryCode: employeeEditDetails[0]?.Code,
        phoneNumber: employeeEditDetails[0]?.Contacts?.find(
          (item) => item.ContactTypeId === 104,
        )?.Contact,
        OrgEmailId: employeeEditDetails[0]?.Contacts?.find(
          (item) => item.ContactTypeId === 101,
        )?.Contact,
        personalemail: employeeEditDetails[0]?.Contacts?.find(
          (item) => item.ContactTypeId === 102,
        )?.Contact,
        ZoneId: employeeEditDetails[0]?.ZoneId,
        RegionId: employeeEditDetails[0]?.RegionId,
      };

      basicInfoForm.setValues(basicInfoData);
    }
  }, [employeeEditDetails]);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == "Add_Employee_header") {
        setEmployeeHeader(msg?.Desc);
      }
    });
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Employee.Update") {
        setEmployeeUpdate(true);
      } else if (UserPermission.PermissionName == "Employee.Delete") {
        setEmployeeDelete(true);
      } else if (UserPermission.PermissionName == "Employee.Create") {
        setEmployeeCreate(true);
      }
    });
  };

  const renderForm = (type) => {
    if (type == "BasicInfo") {
      setBasicInfoFormShow(true);
      setEmplyeeInfoFormShow(false);
      setPersonalInfoFormShow(false);
    } else if (type == "EmplyeeInfo") {
      setBasicInfoFormShow(false);
      setEmplyeeInfoFormShow(true);
      setPersonalInfoFormShow(false);
    }
  };

  const getCountryErrorMessage = (code) => {
    switch (code) {
      case "+91":
        return "Indian numbers must start with 6-9 and have 10 digits";
      case "+1":
        return "US numbers must start with 2-9 and have 10 digits";
      case "+44":
        return "UK numbers must start with 7 and have 10 digits";
      case "+61":
        return "Australian numbers must start with 4 and have 9 digits";
      case "+27":
        return "South African numbers must start with 6-8 and have 9 digits";
      default:
        return "Number must be between 6 to 15 digits";
    }
  };

  const getPhoneRegexByCountry = (code) => {
    switch (code) {
      case "+91":
        return /^[6-9]\d{9}$/;
      case "+1":
        return /^[2-9]\d{9}$/;
      case "+44":
        return /^7\d{9}$/;
      case "+61":
        return /^4\d{8}$/;
      case "+27":
        return /^[6-8]\d{8}$/;
      default:
        return /^\d{6,15}$/;
    }
  };

  const basicInfoValidation = Yup.object().shape({
    firstName: Yup.string()
      .transform((value) => value.trim())
      .required("First name is required"),
    middlename: Yup.string().transform((value) => value.trim()),
    lastName: Yup.string()
      .transform((value) => value.trim())
      .required("Last name is required"),
    employmentid: Yup.string().required("Employment ID is required"),
    DOJ: Yup.string().required("Date of joining is required"),
    selectedCountryCode: Yup.string()
      .nullable()
      .required("Country code is required"),
    phoneNumber: Yup.string()
      .required("Phone number is required")
      .test("valid-phone", function (value) {
        const { selectedCountryCode } = this.parent;
        const regex = getPhoneRegexByCountry(selectedCountryCode);

        if (!regex.test(value || "")) {
          const countryMessage = getCountryErrorMessage(selectedCountryCode);
          return this.createError({
            message: `Invalid phone number format: ${countryMessage}`,
          });
        }

        return true;
      }),
    reportingmanager: Yup.number().min(0, "Invalid manager ID").nullable(),
    OrgEmailId: Yup.string()
      .required("Organization email is required")
      .email("Email is invalid"),
    personalemail: Yup.string()
      .email("Email is invalid")
      .email("Email is invalid"),
    ZoneId: Yup.number()
      .typeError("Zone is required")
      .moreThan(0, "Zone is required")
      .required("Zone is required"),
    RegionId: Yup.number()
      .typeError("Region is required")
      .moreThan(0, "Region is required")
      .required("Region is required"),
  });
  const basicInfoForm = useFormik({
    initialValues: {
      firstName: "",
      middlename: "",
      lastName: "",
      employmentid: "",
      DOJ: "",
      selectedCountryCode: "",
      phoneNumber: "",
      reportingmanager: 0,
      OrgEmailId: "",
      personalemail: "",
      ZoneId: 0,
      RegionId: 0,
    },
    validationSchema: basicInfoValidation,
    validateOnChange: true,
    validateOnBlur: true,

    onSubmit: async (data) => {
      if (Isloading) return; // prevent double submit
      setIsloading(true);

      const paramsAdd = {
        BranchId: userDetails?.BranchId,
        FirstName: data?.firstName,
        MiddleName: data?.middlename ?? "",
        LastName: data?.lastName,
        EmployementId: data?.employmentid?.toString(),
        DateOfJoining: data?.DOJ,
        OfficialEmail: data?.OrgEmailId,
        PersonalEmail: data?.personalemail ?? "",
        Code: data?.selectedCountryCode,
        PhoneNumber: data?.phoneNumber,
        OverseerId: data?.reportingmanager ? Number(data?.reportingmanager) : 0,
        ZoneId: data?.ZoneId ? Number(data?.ZoneId) : 0,
        RegionId: data?.RegionId ? Number(data?.RegionId) : 0,
      };

      try {
        // ================= EXIT FLOW =================
        if (submitActionRef.current === "exit") {
          const response = await addEmployeeData(paramsAdd);

          if (response?.StatusCode === 2000) {
            basicInfoForm.resetForm();

            setTimeout(() => {
              history.push("/TeamDirectory");
            }, 500);
          } else {
            toster.current.error(
              response?.Message || "Something went wrong"
            );
          }
        }

        // ================= CONTINUE FLOW =================
        else if (submitActionRef.current === "continue") {
          // -------- EDIT CASE --------
          if (GUID) {
            const params = {
              Id: employeeEditDetails[0]?.EmpId,
              ...paramsAdd,
              OverseerId: Number(data?.reportingmanager),
            };

            const response = await updateEmployee(params);

            if (response?.StatusCode === 2000) {
              setBasicInfoFormShow(false);
              setEmplyeeInfoFormShow(true);
            } else {
              toster.current.error(
                response?.Message || "Update failed"
              );
            }
          }

          // -------- ADD CASE --------
          else {
            const response = await addEmployeeData(paramsAdd);

            if (response?.StatusCode === 2000) {
              setEmployeeAddId(response?.Data);
              setBasicInfoFormShow(false);
              setEmplyeeInfoFormShow(true);
            } else {
              toster.current.error(
                response?.Message || "Something went wrong"
              );
            }
          }
        }
      } catch (error) {
        console.error("API Error:", error);
        toster.current.error("Something went wrong. Please try again.");
      } finally {
        setIsloading(false); // ALWAYS stop loader
      }
    },
  });
  // const basicInfoForm = useFormik({
  //   initialValues: {
  //     firstName: "",
  //     middlename: "",
  //     lastName: "",
  //     employmentid: "",
  //     DOJ: "",
  //     selectedCountryCode: "",
  //     phoneNumber: "",
  //     reportingmanager: 0,
  //     OrgEmailId: "",
  //     personalemail: "",
  //     ZoneId: 0,
  //     RegionId: 0,
  //   },
  //   validationSchema: basicInfoValidation,
  //   validateOnChange: true,
  //   validateOnBlur: true,
  //   onSubmit: async (data) => {
  //     setIsloading(true);
  //     const paramsAdd = {
  //       BranchId: userDetails?.BranchId,
  //       FirstName: data?.firstName,
  //       MiddleName: data?.middlename ?? "",
  //       LastName: data?.lastName,
  //       EmployementId: data?.employmentid.toString(),
  //       DateOfJoining: data?.DOJ,
  //       OfficialEmail: data?.OrgEmailId,
  //       PersonalEmail: data?.personalemail ?? "",
  //       Code: data?.selectedCountryCode,
  //       PhoneNumber: data?.phoneNumber,
  //       OverseerId: data?.reportingmanager ? Number(data?.reportingmanager) : 0,
  //       ZoneId: data?.ZoneId ? Number(data?.ZoneId) : 0,
  //       RegionId: data?.RegionId ? Number(data?.RegionId) : 0,
  //     };
  //     if (submitActionRef.current === "exit") {
  //       await addEmployeeData(paramsAdd);
  //       basicInfoForm.resetForm();
  //       setTimeout(() => {
  //         history.push("/TeamDirectory");
  //       }, 1000);
  //     } else if (submitActionRef.current === "continue") {
  //       if (GUID) {
  //         const params = {
  //           Id: employeeEditDetails[0]?.EmpId,
  //           BranchId: userDetails?.BranchId,
  //           FirstName: data?.firstName,
  //           MiddleName: data?.middlename,
  //           LastName: data?.lastName,
  //           EmployementId: data?.employmentid.toString(),
  //           DateOfJoining: data?.DOJ,
  //           OfficialEmail: data?.OrgEmailId,
  //           PersonalEmail: data?.personalemail ?? "",
  //           Code: data?.selectedCountryCode,
  //           PhoneNumber: data?.phoneNumber,
  //           OverseerId: Number(data?.reportingmanager),
  //           ZoneId: data?.ZoneId ? Number(data?.ZoneId) : 0,
  //           RegionId: data?.RegionId ? Number(data?.RegionId) : 0,
  //         };
  //         try {
  //           await updateEmployee(params);
  //           setBasicInfoFormShow(false);
  //           setEmplyeeInfoFormShow(true);
  //         } catch (error) {
  //           setIsloading(false);
  //         }
  //         setIsloading(false);
  //       } else {
  //         try {
  //           let employeeData = await addEmployeeData(paramsAdd);
  //           setEmployeeAddId(employeeData?.Data);
  //           setBasicInfoFormShow(false);
  //           setEmplyeeInfoFormShow(true);
  //           setIsloading(false);
  //         } catch (error) {
  //           setIsloading(false);
  //         }
  //       }
  //     }
  //   },
  // });

  async function getObserverNameList() {
    try {
      const observerData = await getObserverName();
      setObserverData(observerData?.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }
  // For get the employee data.
  async function fetchEmployeeIdData() {
    var params = {
      GUID: GUID,
    };
    try {
      setIsloading(false);
      let employeesList = await getEmployeeListDetailsByGUID(params);
      setEmployeeEditDetails([employeesList.Data]);
    } catch (error) { }
  }

  async function getEmployeeKeysData() {
    // Get Employee Keys.
    try {
      let employeeKeys = await getEmployeeKeys();
      setEmployeeKeyDeta(employeeKeys.Data);
    } catch (error) { }
  }

  async function getMasterCountryCode() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Countries",
    };
    try {
      const data = await GetMasterTypeData(params);
      setCountryCode(data?.Data);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  const countryTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <span>
          {option.Code} ({option?.Name})
        </span>
      </div>
    );
  };

  async function getEmployeeIdData() {
    const params = { OrgId: userDetails?.OrgId };
    try {
      let employeeDataId = await getEmployeeID(params);
      if (employeeDataId?.Data?.length > 0) {
        basicInfoForm.setFieldValue(
          "employmentid",
          employeeDataId?.Data[0]?.EmploymentId,
        );
      }
    } catch (error) { }
  }

  async function getmasterZoneList() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "OrgZone",
    };
    try {
      const data = await GetMasterTypeData(params);
      setZoneList(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getmasterRegionList() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "OrgRegion",
    };
    try {
      const data = await GetMasterTypeData(params);
      setmasterRegionList(data?.Data);
      setRegionList(data?.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  const [zoneList, setZoneList] = useState([]);
  const [RegionList, setRegionList] = useState([]);
  const [masterRegionList, setmasterRegionList] = useState([]);
  const onChangeZone = (e) => {
    if (e.value) {
      var filterRegion = masterRegionList.filter((region) => {
        return Number(region?.Code) === e.value;
      });
    } else {
      var filterRegion = masterRegionList;
    }

    setRegionList(filterRegion);
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="form-head d-flex flex-wrap align-items-center mb-3">
            <div className="me-auto">
              {!GUID && (
                <h2 className="font-w600 mb-0">
                  <img src="/images/new-emp.png" />
                  Add New Employee
                </h2>
              )}
              {GUID && (
                <h2 className="font-w600 mb-0">
                  <img src="/images/new-emp.png" />
                  Edit Employee
                </h2>
              )}
              <p className="text-light">{employeeHeader}</p>
            </div>
            {AddMore != 0 && (
              <div
                className="rightside-tabs"
                onClick={() => setAddMore(AddMore - 1) % 3}
              >
                {/* <Link to="Dashboard"> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  className="bi bi-arrow-left-short"
                  viewBox="0 0
 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 8a.5.5 0 0 1-.5.5H5.7
 07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
 .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                  ></path>
                </svg>
              </div>
            )}
          </div>
          {BasicInfoFormShow && (
            <div className="formfill-addemployee">
              <div className="row justify-content-center align-items-center">
                <div className="col-xl-8">
                  <div className="supp-req">
                    <div className="addcourseform">
                      <form onSubmit={basicInfoForm.handleSubmit}>
                        {employeeEditDetails[0]?.FullName && (
                          <h3 className="font-w600 mb-0">
                            {employeeEditDetails[0]?.FullName}
                          </h3>
                        )}
                        <span className="tagtitle">Basic Details</span>
                        <div className="row mt-3 g-3">
                          <div className="col-md-4">
                            <div className="innerform-grp">
                              <label className="form-label">
                                First Name<i className="inValidError">*</i>
                              </label>
                              <div className="cover-form">
                                <input
                                  type="text"
                                  name="firstName"
                                  className={
                                    "form-control" +
                                    (basicInfoForm.errors.firstName &&
                                      basicInfoForm.touched.firstName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={(e) => {
                                    basicInfoForm.setFieldValue(
                                      "firstName",
                                      e.target.value.trimStart(),
                                    );
                                  }}
                                  value={basicInfoForm.values.firstName}
                                />
                              </div>
                            </div>
                            <div className="invalid-feedback">
                              {basicInfoForm.errors.firstName &&
                                basicInfoForm.touched.firstName
                                ? basicInfoForm.errors.firstName
                                : null}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="innerform-grp">
                              <label className="form-label">Middle Name</label>
                              <div className="cover-form">
                                <input
                                  type="text"
                                  name="middlename"
                                  className={
                                    "form-control" +
                                    (basicInfoForm.errors.middlename &&
                                      basicInfoForm.touched.middlename
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={(e) => {
                                    basicInfoForm.setFieldValue(
                                      "middlename",
                                      e.target.value.trimStart(),
                                    );
                                  }}
                                  value={basicInfoForm.values.middlename}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="innerform-grp">
                              <label className="form-label">
                                Last Name<i className="inValidError">*</i>
                              </label>
                              <div className="cover-form">
                                <input
                                  type="text"
                                  name="lastName"
                                  className={
                                    "form-control" +
                                    (basicInfoForm.errors.lastName &&
                                      basicInfoForm.touched.lastName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={(e) => {
                                    basicInfoForm.setFieldValue(
                                      "lastName",
                                      e.target.value.trimStart(),
                                    );
                                  }}
                                  value={basicInfoForm.values.lastName}
                                />
                              </div>

                              <div className="invalid-feedback">
                                {basicInfoForm.errors.lastName &&
                                  basicInfoForm.touched.lastName
                                  ? basicInfoForm.errors.lastName
                                  : null}
                              </div>
                            </div>
                          </div>

                          {basicInfoForm.values.lastName && (
                            <div className="col-md-6">
                              <div className="innerform-grp">
                                <label className="form-label d-flex justify-content-between">
                                  <span>
                                    {" "}
                                    Employment Id
                                    <i className="inValidError">*</i>
                                  </span>
                                  <span
                                    className="btn-link fs-9"
                                    onClick={() => getEmployeeIdData()}
                                  >
                                    Get Latest Employment Id
                                  </span>
                                </label>
                                <div className="cover-form">
                                  <input
                                    type="text"
                                    name="employmentid"
                                    className={
                                      "form-control" +
                                      (basicInfoForm.errors.employmentid &&
                                        basicInfoForm.touched.employmentid
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={basicInfoForm.handleChange}
                                    value={basicInfoForm.values.employmentid}
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {basicInfoForm.errors.employmentid &&
                                    basicInfoForm.touched.employmentid
                                    ? basicInfoForm.errors.employmentid
                                    : null}
                                </div>
                              </div>
                            </div>
                          )}
                          {basicInfoForm.values.lastName && (
                            <div className="col-md-6">
                              <div className="innerform-grp">
                                <label className="form-label">
                                  Date of Joining
                                  <i className="inValidError">*</i>
                                </label>
                                <div className="cover-form">
                                  <input
                                    type="date"
                                    name="DOJ"
                                    onClick={(e) =>
                                      e.target.showPicker &&
                                      e.target.showPicker()
                                    }
                                    className={
                                      "form-control" +
                                      (basicInfoForm.errors.DOJ &&
                                        basicInfoForm.touched.DOJ
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={basicInfoForm.handleChange}
                                    value={basicInfoForm.values.DOJ}
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {basicInfoForm.errors.DOJ &&
                                    basicInfoForm.touched.DOJ
                                    ? basicInfoForm.errors.DOJ
                                    : null}
                                </div>
                              </div>
                            </div>
                          )}
                          {basicInfoForm.values.DOJ && (
                            <div className="col-md-6">
                              <div className="innerform-grp">
                                <label className="form-label">
                                  Phone Number<i className="inValidError">*</i>
                                </label>
                                <div className="cover-form d-flex gap-2 phone-drop-area">
                                  <Dropdown
                                    value={
                                      basicInfoForm.values.selectedCountryCode
                                    }
                                    options={countryCode}
                                    onFocus={(e) => e.target.click()}
                                    onChange={(e) => {
                                      basicInfoForm.setFieldValue(
                                        "selectedCountryCode",
                                        e.value,
                                      );
                                    }}
                                    className={`w-auto ${basicInfoForm.touched
                                        .selectedCountryCode &&
                                        basicInfoForm.errors.selectedCountryCode
                                        ? "is-invalid"
                                        : ""
                                      }`}
                                    optionLabel="Code"
                                    optionValue="Code"
                                    filter
                                    itemTemplate={countryTemplate}
                                    placeholder="Code"
                                  />
                                  <input
                                    type="text"
                                    name="phoneNumber"
                                    className={
                                      "form-control" +
                                      (basicInfoForm.errors.phoneNumber &&
                                        basicInfoForm.touched.phoneNumber
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d*$/.test(value)) {
                                        basicInfoForm.setFieldValue(
                                          "phoneNumber",
                                          value,
                                        );
                                      }
                                    }}
                                    value={basicInfoForm.values.phoneNumber}
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {basicInfoForm.errors.phoneNumber &&
                                    basicInfoForm.touched.phoneNumber
                                    ? basicInfoForm.errors.phoneNumber
                                    : null}
                                  {basicInfoForm.touched.selectedCountryCode &&
                                    basicInfoForm.errors
                                      .selectedCountryCode && (
                                      <div className="invalid-feedback">
                                        {
                                          basicInfoForm.errors
                                            .selectedCountryCode
                                        }
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          )}
                          {basicInfoForm.values.phoneNumber && (
                            <div className="col-md-6">
                              <div className="innerform-grp">
                                <label className="form-label">
                                  Reporting Manager
                                </label>
                                <div className="cover-form">
                                  <Dropdown
                                    name="reportingmanager"
                                    value={
                                      basicInfoForm.values.reportingmanager
                                    }
                                    onChange={(e) => {
                                      basicInfoForm.setFieldValue(
                                        "reportingmanager",
                                        e.value,
                                      );
                                    }}
                                    options={observerData?.toSpliced(0, 0, {
                                      id: 0,
                                      fullname: "None",
                                    })}
                                    optionLabel="fullname"
                                    optionValue="id"
                                    filter
                                    placeholder="Reporting Manager"
                                  />
                                </div>
                              </div>
                            </div>
                          )}

                          {basicInfoForm.values.phoneNumber && (
                            <div className="col-md-6">
                              <div className="innerform-grp">
                                <label className="form-label">
                                  Organization Email Id
                                  <i className="inValidError">*</i>
                                </label>
                                <div className="cover-form">
                                  <input
                                    type="text"
                                    name="OrgEmailId"
                                    className={
                                      "form-control" +
                                      (basicInfoForm.errors.OrgEmailId &&
                                        basicInfoForm.touched.OrgEmailId
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={basicInfoForm.handleChange}
                                    value={basicInfoForm.values.OrgEmailId}
                                    disabled={GUID}
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {basicInfoForm.errors.OrgEmailId &&
                                    basicInfoForm.touched.OrgEmailId
                                    ? basicInfoForm.errors.OrgEmailId
                                    : null}
                                </div>
                              </div>
                            </div>
                          )}
                          {basicInfoForm.values.OrgEmailId && (
                            <div className="col-md-6">
                              <div className="innerform-grp">
                                <label className="form-label">
                                  Personal Email Id
                                  <i className="inValidError">*</i>
                                </label>
                                <div className="cover-form">
                                  <input
                                    type="text"
                                    name="personalemail"
                                    className={
                                      "form-control" +
                                      (basicInfoForm.errors.personalemail &&
                                        basicInfoForm.touched.personalemail
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={basicInfoForm.handleChange}
                                    value={basicInfoForm.values.personalemail}
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {basicInfoForm.errors.personalemail &&
                                    basicInfoForm.touched.personalemail
                                    ? basicInfoForm.errors.personalemail
                                    : null}
                                </div>
                              </div>
                            </div>
                          )}

                          {basicInfoForm.values.personalemail && (
                            <div className="col-md-6">
                              <div className="innerform-grp">
                                <label className="form-label">
                                  Zone
                                  <i className="inValidError">*</i>
                                </label>
                                <div className="cover-form">
                                  <Dropdown
                                    name="ZoneId"
                                    value={basicInfoForm.values.ZoneId}
                                    onChange={(e) => {
                                      basicInfoForm.setFieldValue(
                                        "ZoneId",
                                        e.value,
                                      );

                                      onChangeZone(e);
                                    }}
                                    onBlur={() =>
                                      basicInfoForm.setFieldTouched(
                                        "ZoneId",
                                        true,
                                      )
                                    }

                                    className={`${basicInfoForm.touched.ZoneId &&
                                        basicInfoForm.errors.ZoneId
                                        ? "is-invalid"
                                        : ""
                                      }`}
                                    options={zoneList.toSpliced(0, 0, {
                                      Id: null,
                                      Name: "None",
                                    })}
                                    optionLabel="Name"
                                    optionValue="Id"
                                    placeholder="Select Zone"
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {basicInfoForm.errors.ZoneId &&
                                    basicInfoForm.touched.ZoneId
                                    ? basicInfoForm.errors.ZoneId
                                    : null}
                                </div>
                              </div>
                            </div>
                          )}

                          {basicInfoForm.values.ZoneId && (
                            <div className="col-md-6">
                              <div className="innerform-grp">
                                <label className="form-label">
                                  Region
                                  <i className="inValidError">*</i>
                                </label>
                                <div className="cover-form">
                                  <Dropdown
                                    name="RegionId"
                                    value={basicInfoForm.values.RegionId}
                                    onChange={(e) => {
                                      basicInfoForm.setFieldValue(
                                        "RegionId",
                                        e.value,
                                      );
                                    }}
                                    onBlur={() =>
                                      basicInfoForm.setFieldTouched(
                                        "RegionId",
                                        true,
                                      )
                                    }
                                    className={`${basicInfoForm.touched.RegionId &&
                                        basicInfoForm.errors.RegionId
                                        ? "is-invalid"
                                        : ""
                                      }`}
                                    options={RegionList.toSpliced(0, 0, {
                                      Id: null,
                                      Name: "None",
                                    })}
                                    optionLabel="Name"
                                    optionValue="Id"

                                    placeholder="Region Id"
                                  />
                                </div>
                                <div className="invalid-feedback">
                                  {basicInfoForm.errors.RegionId &&
                                    basicInfoForm.touched.RegionId
                                    ? basicInfoForm.errors.RegionId
                                    : null}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="col-md-12 mt-4">
                          {employeeCreate &&
                            basicInfoForm.values.OrgEmailId && (
                              <div className="btns-grp text-right">
                                {!GUID && (
                                  <button
                                    type="submit"
                                    className="savebutton"
                                    onClick={() => {
                                      submitActionRef.current = "exit";
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="17"
                                      height="17"
                                      fill="currentColor"
                                      className="bi bi-check-circle me-2"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                      <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"></path>
                                    </svg>
                                    Save & Exit
                                  </button>
                                )}
                                {basicInfoForm.values.OrgEmailId && (
                                  <button
                                    type="submit"
                                    onClick={() => {
                                      submitActionRef.current = "continue";
                                    }}
                                    className="publish-click"
                                  >
                                    Save & Continue
                                  </button>
                                )}
                              </div>
                            )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4">
                  <div className="side-add-section">
                    <img
                      src="/images/no-data-found/Employee_banner.png"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {EmplyeeInfoFormShow && (
            <div className="formfill-addemployee">
              <div className="row justify-content-center">
                <div className="col-xl-8">
                  <div className="supp-req">
                    <div className="addcourseform">
                      <DynamicEmployeeForm
                        employeeKeyDeta={employeeKeyDeta}
                        renderForm={renderForm}
                        employeeEditDetails={employeeEditDetails}
                        backButtonHideStatus={backButtonHide}
                        employeeAddId={employeeAddId}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xl-4">
                  <div className="side-add-section">
                    <img
                      src="/images/no-data-found/Employee_banner.png"
                      className="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default AddNewEmployee;
